import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { WizardProvider } from './context/WizardContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Step1Project from './pages/wizard/Step1Project';
import Step2Template from './pages/wizard/Step2Template';
import Step3DataSources from './pages/wizard/Step3DataSources';
import Step4Relationships from './pages/wizard/Step4Relationships';
import Step5Mapping from './pages/wizard/Step5Mapping';
import ProjectOverview from './pages/ProjectOverview';
import ProjectEdit from './pages/ProjectEdit';
import DataSourcesOverview from './pages/DataSourcesOverview';
import FormulareOverview from './pages/FormulareOverview';
import PDFGeneratePage from './pages/PDFGeneratePage';
import Layout from './components/Layout';
import ErrorBoundary from './components/ErrorBoundary';
import './App.css';

function AppNew() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <WizardProvider>
            <ProtectedRoute>
              <div className="App">
                <Routes>
                  <Route path="/" element={<Navigate to="/projects" replace />} />
                  <Route path="/projects" element={<Layout><ProjectOverview /></Layout>} />
                  <Route path="/projects/edit/:id" element={<Layout><ProjectEdit /></Layout>} />
                  <Route path="/datasources" element={<Layout><DataSourcesOverview /></Layout>} />
                  <Route path="/formulare" element={<Layout><FormulareOverview /></Layout>} />
                  <Route path="/generate" element={<Layout><PDFGeneratePage /></Layout>} />
                  <Route path="/wizard/project" element={<Layout><Step1Project /></Layout>} />
                  <Route path="/wizard/template" element={<Layout><Step2Template /></Layout>} />
                  <Route path="/wizard/datasources" element={<Layout><Step3DataSources /></Layout>} />
                  <Route path="/wizard/relationships" element={<Layout><Step4Relationships /></Layout>} />
                  <Route path="/wizard/mapping" element={<Layout><Step5Mapping /></Layout>} />
                  <Route path="*" element={<Navigate to="/projects" replace />} />
                </Routes>
              </div>
            </ProtectedRoute>
          </WizardProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default AppNew;
